export default __webpack_public_path__ + "static/media/LeftArrow.ad6ba60d.svg";